import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IJobSetting extends IModel {
	group?: number;
	name?: string;
	value?: string;
	sortIndex?: number;
}

const jobSettingFactory = modelFactory.createFactory<IJobSetting>('JobSetting', _.assign({}, model, {
	group: {
		rules: validator.enum('jobSettingGroups') // allow 0
	},
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	sortIndex: {
		setFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	}
}));

export default jobSettingFactory;